import React, { PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import Input from '../../form/Input';
import RaisedButton from 'material-ui/RaisedButton';
import { Card, CardText, CardTitle } from 'material-ui/Card';
import style from './../style';

import {
  UPDATE_PASSWORD_TOKEN_NEW,
  UPDATE_PASSWORD_TOKEN_EXPIRED,
  UPDATE_PASSWORD_TOKEN_USED,
  UPDATE_PASSWORD_TOKEN_WRONG
} from '../../../actions/auth'

const validate = (values) => {
  const errors = {};
  if (!values.password) {
    errors.password = 'Required';
  } else if (values.password.length < 6) {
    errors.password = 'Weak password';
  }

  if (values.password !== values.repeatPassword) {
    errors.repeatPassword = 'Incorrect password';
  }
  return errors;
};

class UpdatePassword extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    updateToken: PropTypes.string,
    status: PropTypes.string,
    checkUpdatePasswordToken: PropTypes.func.isRequired,
    updatePassword: PropTypes.func.isRequired
  };

  componentWillMount() {
    if (!this.props.status) {
      this.props.checkUpdatePasswordToken(this.props.params.token);
    }
  }

  onSubmit({password}) {
    return this.props.updatePassword(password, this.props.updateToken);
  }

  render() {
    switch(this.props.status) {
      case UPDATE_PASSWORD_TOKEN_NEW:
        const { fields: {password, repeatPassword}, handleSubmit, submitting, invalid} = this.props;
        return (<form onSubmit={handleSubmit(data => this.onSubmit(data))}>
          <Card className={style.formCard}>
            <CardTitle>Update your password</CardTitle>
            <CardText>
              <Input type="password" floatingLabelText="New password" {...password}/>
              <Input type="password" floatingLabelText="Repeat password" {...repeatPassword}/>
              <RaisedButton label="Update password" disabled={submitting || invalid} raised primary type="submit"/>
            </CardText>
          </Card>
        </form>);
      case UPDATE_PASSWORD_TOKEN_EXPIRED:
        return (<h1>Your token has been expired.</h1>);
      case UPDATE_PASSWORD_TOKEN_USED:
        return (<h1>Your token has already been used.</h1>);
      case UPDATE_PASSWORD_TOKEN_WRONG:
        return (<h1>404</h1>);
      default:
        return (<h1>Loading...</h1>);
    }
  }
}

export default reduxForm({
  form: 'update-password',
  fields: ['password', 'repeatPassword'],
  validate
})(UpdatePassword);



// WEBPACK FOOTER //
// ./src/components/auth/UpdatePassword/component.jsx